import React from 'react';
import propTypes from 'prop-types';

// The color prop will change pins head, it's useful mainly for maps
function Pin({ color = '#555' }) {
  return (
    <svg viewBox="0 0 32.8 59.5" xmlns="http://www.w3.org/2000/svg">
      <path d="M-1 -1H33.8V60.5H-1z" fill="none" />
      <path
        d="M7.227 22.28H10.694V59.176H7.227z"
        fill="#fff"
        stroke="#000"
        strokeWidth="null"
        transform="rotate(21.582 8.96 40.728)"
      />
      <circle
        className="cls-1"
        cx="20.123"
        cy="12.828"
        fill={color}
        r="12.123"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Pin.propTypes = {
  color: propTypes.string,
};

export default Pin;
